import api from './api';

// Sessão 1 Frente A — endpoint §6.3 do PLANO
// GET /admin/investigations/{type}/{value}

export type InvestigationType = 'ip' | 'hwid' | 'account_id';

export interface Reputation {
  session_count?: number;
  distinct_accounts_count?: number;
  distinct_hwids_count?: number;
  distinct_ips_count?: number;
  incident_count?: number;
  max_severity?: number;
  hard_incident_count?: number;
  hard_incident_count_24h?: number;
  last_seen_at?: string;
  computed_at?: string;
}

export interface SessionSummary {
  id: string;
  session_id: string;
  // user_id = login vinculado (quando a sessão autenticou). Opcional: sessões
  // pré-login não têm dono e o backend pode omitir o campo.
  user_id?: string | null;
  account_id: string;
  hwid: string;
  ip: string;
  client_build: string;
  risk_score: number;
  status: string;
  decision: string;
  decision_real: string;
  first_heartbeat_at: string;
  last_heartbeat_at: string;
}

export interface IncidentSummary {
  id: string;
  attack_category: string;
  severity_max: number;
  event_count: number;
  occurrence_sum: number;
  status: string;
  first_seen_at: string;
  last_seen_at: string;
  summary?: string;
}

export interface PaginatedList<T> {
  data: T[];
  total: number;
}

export interface CrossCorrelation {
  accounts: string[];
  hwids: string[];
  ips: string[];
}

export interface InvestigationResult {
  target: {
    type: InvestigationType;
    value: string;
    reputation: Reputation;
  };
  sessions: PaginatedList<SessionSummary>;
  incidents: PaginatedList<IncidentSummary>;
  cross_correlation: CrossCorrelation;
}

export async function investigate(
  type: InvestigationType,
  value: string,
): Promise<InvestigationResult> {
  const resp = await api.get<InvestigationResult>(
    `/admin/investigations/${type}/${encodeURIComponent(value)}`,
  );
  return resp.data;
}
